import { c as _c } from "react/compiler-runtime";
import './mini-gallery.scss';
import React from 'react';
import { Image } from '@sola/ark-core/atoms/image/image.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import childLaughing from '../../images/child-laughing.jpg';
import childSmiling from '../../images/child-smiling.jpg';
import groupPlaying from '../../images/group-playing.jpg';
import groupWaving from '../../images/group-waving.jpg';
import mom from '../../images/mom-w-baby.jpg';
import pairSmiling from '../../images/pair-smiling.jpg';
export interface MiniGalleryProps {
  className?: string;
}

// @TODO should these be translatable?
const items = [{
  src: mom,
  alt: 'Image of mother carrying baby'
}, {
  src: groupWaving,
  alt: 'Image of group of children waving'
}, {
  src: groupPlaying,
  alt: 'Image of group of children playing'
}, {
  src: childLaughing,
  alt: 'Image of child laughing'
}, {
  src: pairSmiling,
  alt: 'Image of man and girl smiling'
}, {
  src: childSmiling,
  alt: 'Image of child smiling'
}];
export const MiniGallery: React.FC<MiniGalleryProps> = t0 => {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("MiniGallery flex gap-comfy-sm overflow-hidden md:overflow-visible", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = items?.map(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className={t1}>{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(t0) {
  const {
    src,
    alt
  } = t0;
  return <div key={typeof src === "string" ? src : alt} className="MiniGallery__item-wrapper"><Image src={src} alt={alt} width={100} height={100} className="MiniGallery__item" /></div>;
}